import useCartProducts from './useCartProducts'
import { ShoppingCartTotal } from '../provider/types'
import { calculateRewardTotals, roundPrice } from '@/shop/src/utils/shopItemUtils'

const getDiscount = (price: string, originalPrice: string) =>
  price && originalPrice ? roundPrice(parseFloat(originalPrice) - parseFloat(price)) : ''

export function useShoppingCartTotals(): {
  total: ShoppingCartTotal | undefined
} {
  const { products, price, priceWei, originalPrice, priceDubi, priceWeiDubi } = useCartProducts()
  const { loot } = calculateRewardTotals(products)

  return {
    total: {
      price: {
        crypto: {
          wei: { Purpose: priceWei, Dubi: priceWeiDubi },
          human: { Purpose: price, Dubi: priceDubi },
        },
        totals: {
          totalPrps: price,
          totalDubi: priceDubi,
          originalTotalPrps: originalPrice,
          discountSavingsPrps: getDiscount(price, originalPrice),
          discountSavingsDubi: getDiscount(priceDubi, originalPrice),
        },
      },
      loot: loot,
    },
  }
}
